define('SC.ItemBadges.1.0.0.ItemBadges', [
    'SC.Configuration',

    'ItemBadges.ProductDetail',
    'ItemBadges.ProductList',
    'ItemBadges.GlobalViews',

    'underscore'
], function ItemBadges(
    Configuration,

    ItemBadgesProductDetail,
    ItemBadgesProductList,
    ItemBadgesGlobalViews,

    _
) {
    'use strict';


    return {
        mountToApp: function mountToApp(application) {
            var itemBadgesConfiguration = Configuration.get('itemBadges');
            var facetExclude;

            if (itemBadgesConfiguration.showInFacet) {
                Configuration.facets.push({
                    id: 'custitem_ef_badges',
                    priority: 20,
                    behavior: 'multi',
                    name: _(itemBadgesConfiguration.facetName).translate()
                });
            } else {
                _.each(Configuration.searchApiMasterOptions, function eachApiOptions(value) {
                    facetExclude = value['facet.exclude'];

                    if (!_.isEmpty(facetExclude)) {
                        if (facetExclude.indexOf('custitem_ef_badges') === -1) {
                            facetExclude = facetExclude + ',custitem_ef_badges'; // eslint-disable-line operator-assignment
                        }
                    } else {
                        facetExclude = 'custitem_ef_badges';
                    }

                    _.extend(value, {
                        'facet.exclude': facetExclude
                    });
                });
            }

            ItemBadgesProductDetail.loadProductDetailItemBadges(application);
            ItemBadgesProductList.loadProductListItemBadges(application);
            ItemBadgesGlobalViews.loadGlobalViewsItemBadges(application);
        }
    };
});
